import classnames from 'classnames/bind';
import styles from './index.module.less';

const cx = classnames.bind(styles);

export const ReferrerInvalidTip = ({ isRecommend = false }) => {
  return (
    <p id={cx('invalid-tip')}>
      <img src="https://static.fuxi.netease.com/yaotai/portal/index/liy93ug7_674023.png" alt="" />
      “推荐有奖计划”仅面向新用户，
      <br />
      {isRecommend ? '您推荐的好友' : '您'}
      已经是网易瑶台的 <span>老朋友</span> 啦～
    </p>
  );
};
